import { warrantyProcess } from './warranty-process-de.i18n';

export const de = {
  warrantyProcess
};